import React, { useEffect } from 'react';
import './avisosprivacidad.css';
import { avisosprivacidad } from '../../json/avisosprivacidad';

const Avisosprivacidad = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Avisos de Privacidad de la Secretaría de Bienestar e Inclusión Social</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Fundamento Legal</h5>
                <p>
                El tratamiento de sus datos y las finalidades para las que son recabadas son con estricto apego a la ley, de conformidad con establecido en los artículos 12, 13, 19, 20, 22, 32, 34, 39, 43, 70, 75, 76, 79, 81 y demás relativos y aplicables de la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Hidalgo (LPDPPSOEH).
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>¿Qué es un Aviso de Privacidad?</h5>
                <p>
                Es un documento físico, electrónico o en cualquier otro formato generado por el responsable, que es puesto a disposición del titular con el objeto de informarle los propósitos principales del tratamiento al que serán sometidos sus datos personales. (Artículo 3, fracción I (LPDPPSOEH) El aviso de privacidad deberá caracterizarse por ser sencillo, con información necesaria, expresado en lenguaje claro y comprensible, y con una estructura y diseño que facilite su entendimiento. El aviso de privacidad se pondrá a disposición del titular en dos modalidades:
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Aviso de Privacidad simplificado</h5>
                <p>
                <b>Artículo 41.</b> El responsable deberá poner a disposición del titular el aviso de privacidad simplificado en los siguientes momentos:
                <ul>
                  <li>Cuando los datos personales se obtienen de manera directa del titular previo a la obtención de los mismos; y<br />                    
                  </li>
                  <li>Cuando los datos personales se obtienen de manera indirecta del titular previo al uso o aprovechamiento de éstos.<br />
                  </li>
                </ul>
                </p>
                <h6 style={{ fontWeight: 'bold' }}>Modalidades:</h6>
                <p>
                <ul>
                  <li>I.	La denominación del responsable.<br />                    
                  </li>
                  <li>II.	Las finalidades del tratamiento para las cuales se obtienen los datos personales, distinguiendo aquéllas que requieran el consentimiento del titular;<br />
                  </li>
                  <li>III.	Cuando se realicen transferencias de datos personales que requieran consentimiento, se deberá informar:<br />
                  <ul>
                    <li>a) Las autoridades, poderes, entidades, órganos y organismos gubernamentales de los tres órdenes de gobierno y las personas físicas o morales de carácter privado a las que se transfieren los datos personales, y
                    </li>
                    <li>b) Las finalidades de estas transferencias;
                    </li>
                  </ul>
                  </li>
                  <li>IV.	Los mecanismos y medios disponibles para que el titular, en su caso, pueda manifestar su negativa para el tratamiento de sus datos personales para finalidades y transferencias de datos personales que requieren el consentimiento del titular; y
                  </li>
                  <li>V.	El sitio donde se podrá consultar el aviso de privacidad integral.
                  </li>
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Aviso de Privacidad Integral</h5>
                <p><i>Deberá contener la siguiente información:</i>
                <ul>
                  <li>I.	El domicilio del responsable.<br />                    
                  </li>
                  <li>II.	Los datos personales que serán sometidos a tratamiento, identificando aquéllos que sean sensibles;<br />
                  </li>
                  <li>III.	El fundamento legal que faculta expresamente al responsable para llevar a cabo:<br />
                  <ul>
                    <li>a) El tratamiento de datos personales; y
                    </li>
                    <li>b) Las transferencias de datos personales que, en su caso, efectúe con autoridades, poderes, entidades, órganos y organismos gubernamentales de los tres órdenes de gobierno y las personas físicas o morales de carácter privado;
                    </li>
                  </ul>
                  </li>
                  <li>IV.	Los mecanismos, medios y procedimientos disponibles para ejercer los derechos ARCO;<br />
                  </li>
                  <li>V.	El domicilio de la Unidad de Transparencia; y
                  </li>
                  <li>VI.	Los medios a través de los cuales el responsable comunicará a los titulares los cambios al aviso de privacidad.
                  </li>
                </ul>
                </p>
                
                
                <h5 style={{ fontWeight: 'bold' }}>Avisos de privacidad de la SEBISO</h5>
            <table className='table-normal-text' style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}><b>Área Responsable</b></th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}><b>Simplificado</b></th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}><b>Integral</b></th>
                </tr>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Secretaría de Bienestar e Inclusión Social
                  <ul>
                    <li>Material Fotográfico y de Video
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Mat_FotyV_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>

                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Mat_FotyV_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>
               
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Dirección General de Asistencia, Atención y Protección
                  <ul>
                    <li>Asesorías Jurídicas
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Ases_jurid_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Ases_jurid_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Subsecretaría de Inclusión y Desarrollo
                  <ul>
                    <li>Programa Apoyo para el Bienestar y Desarrollo
                    </li>
                    <li>Programa Bienestar de Madres Trabajadoras
                    </li>
                    <li>Programa de Subsidio al Servicio de Verificación Vehicular
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienDes_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienMaT_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/VerVeh_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienDes_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienMaT_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                 <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/VerVeh_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>

                 <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Subsecretaría de Desarrollo Social y Humano
                  <ul>
                    <li>Programa Desarrollo Inclusivo
                    </li>
                    <li>Programa Atención al Pueblo
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/DesInc_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/PatnPue_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/DesInc_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/PatnPue_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>

                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Dirección General de Inclusión para las Personas con Discapacidad
                  <ul>
                    <li>Atención Integral Primer Contacto a Personas con Discapacidad
                    </li>
                    <li>Programa de Bienestar de Personas Cuidadoras de Personas con discapacidad
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/AtnPerDisc_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienPerDisc_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/AtnPerDisc_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienPerDisc_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>

                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Dirección General de Atención al Migrante
                  <ul>
                    <li>Asistencia Social
                    </li>
                    <li>Documentos de viaje Internacional
                    </li>
                    <li>Busqueda de Extraviados y Detenidos
                    </li>
                    <li>Doble Nacionalidad
                    </li>
                    <li>Invierte en Ti, Invierte en Hidalgo
                    </li>
                    <li>Reencuentro Familiar
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/AsSoc_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/DocsViaInt_S'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BusqExtyD_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/DobNac_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/InvTi_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/ReenFam_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/AsSoc_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/DocsViaInt_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BusqExtyD_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BusqExtyD_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/InvTi_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/ReenFam_I.pdf
'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>

                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Subsecretaría de Participación Social y Fomento Artesanal
                  <ul>
                    <li>Programa Bienestar Para Personas Artesanas
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienPersArt_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/BienPersArt_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Dirección General de Fomento Artesanal
                  <ul>
                    <li>Programa Fomento Artesanal 
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/FomArt_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/FomArt_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                  </th>
                </tr>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
                  Coordinación Administrativa
                  <ul>
                    <li>Dirección de Recursos Humanos
                    <ul>
                    <li>Capacitación de Personal
                    </li>
                    <li>Movimientos de Personal
                    </li>
                    <li>Control de Asistencia
                    </li>
                    </ul>
                    </li>
                    <li>Dirección de Recursos Financieros
                    <ul>
                    <li>Proveedores
                    </li>
                    <li>Viaticos
                    </li>
                    </ul>
                    </li>
                    <li>Dirección de Control y Seguimiento a Auditoría
                    <ul>
                    <li>Procesos de Auditoría y Fiscalización, e Identificación de Integrantes del Comité de Control y Desempeño institucional
                    </li>
                    </ul>
                    </li>
                  </ul>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}><br />
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/CapPers_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/MovPers_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/CtrlAsis_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br /><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Provrs_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Viat_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br /><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/ProcAudyFisc_S.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                  <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}><br />
                  <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/CapPers_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/MovPers_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/CtrlAsis_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br /><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Provrs_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/Viat_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a><br /><br />
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/avisosp/ProcAudyFisc_I.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >pdf</a>
                  </th>
                </tr>
                
              </thead>
             
            </table>
              
               </div>
            </div>
            
          </div>
        </div>
      </div>    
     
    </div>
  );
};

export default Avisosprivacidad;

